import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["locationDetails"]
  
  connect() {
    // Hide location details initially if no community selected
    if (!this.element.querySelector('select[name*="community_id"]').value) {
      this.hideLocationDetails()
    }
  }
  
  communityChanged(event) {
    if (event.target.value) {
      this.showLocationDetails()
    } else {
      this.hideLocationDetails()
    }
  }
  
  showLocationDetails() {
    if (this.hasLocationDetailsTarget) {
      this.locationDetailsTarget.classList.remove("hidden")
      this.locationDetailsTarget.classList.add("animate-fade-in")
    }
  }
  
  hideLocationDetails() {
    if (this.hasLocationDetailsTarget) {
      this.locationDetailsTarget.classList.add("hidden")
    }
  }
}